<template>
  <div class="secure-payment-container">
    <h2>{{ title }}</h2>
    <ul class="secure-payment-images">
      <li v-for="method in securePaymentMethods" :key="method.name" class="payment-image">
        <img :src="method.logo" :alt="method.name" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import americanExpressLogo from '@/assets/payment-methods/americanExpressLogo.svg'
import applePayLogo from '@/assets/payment-methods/applePayLogo.svg'
import discoverLogo from '@/assets/payment-methods/discoverLogo.png'
import googlePayLogo from '@/assets/payment-methods/googlePayLogo.svg'
import maestroLogo from '@/assets/payment-methods/maestroLogo.svg'
import masterCardLogo from '@/assets/payment-methods/masterCardLogo.svg'
import visaLogo from '@/assets/payment-methods/visaLogo.png'

withDefaults(defineProps<{ title?: string }>(), { title: 'We only use secure payment methods' })

const securePaymentMethods = [
  { name: 'Visa', logo: visaLogo },
  { name: 'MasterCard', logo: masterCardLogo },
  { name: 'PayPal', logo: maestroLogo },
  { name: 'American Express', logo: americanExpressLogo },
  { name: 'Discover', logo: discoverLogo },
  { name: 'Apple Pay', logo: applePayLogo },
  { name: 'Google Pay', logo: googlePayLogo },
]
</script>

<style scoped lang="scss">
.secure-payment-images img{
  width: 55px;
  height: 33px;
}
</style>
